import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { buildCustomerProfileUrl } from '../../helpers/customers';

function useNavigateToCustomerProfile() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (customerId: string) => {
      navigate(buildCustomerProfileUrl(customerId, location));
    },
    [navigate, location],
  );
}

export default useNavigateToCustomerProfile;
